<section *ngIf="data && data.length" class="mt-3 d-none d-sm-block" [ngClass]="{'d-none': !show}">
  <div matBadge="{{data.length}}" matBadgeOverlap="false" matBadgeColor="warn" matBadgePosition="after"></div>
  <mat-expansion-panel [expanded]="expanded">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="h6" i18n>Dotazníky</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div *ngFor="let d of data; let last = last;" title="{{ d.nazov }}">
      <div class="dotaznik" (click)="openDotaznik(d)">
        <a title="{{ d.nazov }}" *ngIf="!d.ukonceny">
          <b innerHTML="{{ getNazov(d) }}"></b>
        </a>
        <b *ngIf="d.ukonceny" innerHTML="{{ getNazov(d) }}"></b>
        <div [innerHTML]="d.vyzva"></div>
        <div>
          <span i18n>Obdobie vypĺňania</span>:
          {{d.datumOd | date}}
          <span *ngIf="d.casOd" style="font-size: 12px; color: gray;">&nbsp;<mat-icon style="font-size: 12px; width: 14px;">schedule</mat-icon>{{d.casOd}}&nbsp;</span>
          &nbsp;&nbsp;-&nbsp;&nbsp;
          {{d.datumDo | date}}
          <span *ngIf="d.casDo" style="font-size: 12px; color: gray;">&nbsp;<mat-icon style="font-size: 12px; width: 14px;">schedule</mat-icon>{{d.casDo}}&nbsp;</span>
        </div>
        <span i18n>rozpracovaný</span>: {{d.rozpracovany|anoNie|translate}},
        <span i18n>ukončený</span>: {{d.ukonceny|anoNie|translate}}
      </div>
      <br *ngIf="!last"/><br *ngIf="!last"/>
    </div>

  </mat-expansion-panel>
</section>
